import Box from '@componentPrimitives/Box';
import Txt from '@componentPrimitives/Txt';
import BlockHeader from '@components/BlockHeader';
import { BlockContainer } from '@components/Blocks';
import Formie from '@components/Formie';
import { createBlock } from '@lib/features/blocks';
import { useGlobal } from '@lib/store';
import React from 'react';

export type SubscribeFormBlockProps = {
  /**/
};

const SubscribeFormBlock = createBlock<'blocks_subscribeForm_BlockType'>(
  ({ heading: customHeading, content: customContent }) => {
    const subscribeForm = useGlobal('subscribeForm');
    const heading = customHeading || subscribeForm?.heading;
    const content = customContent || subscribeForm?.content;
    return (
      <BlockContainer maxWidth="md">
        <Box rounded bordered cx={{ padding: 'lg' }}>
          <Txt variant="h5" as="h2" cx={{ mB: 'md' }}>
            {heading}
          </Txt>
          <Txt html cx={{ mB: 'md' }}>
            {content}
          </Txt>
          <Formie form={subscribeForm?.form ?? undefined} />
        </Box>
      </BlockContainer>
    );
  }
);

export default SubscribeFormBlock;
